// app state slice must contain an initialHistoryData property

import { createSlice } from '@reduxjs/toolkit';
import { QuestionListResponse } from '../../../tpc/types';

interface AppState {
    initialHistoryData: QuestionListResponse | undefined;
    selectedQuestionUuid: string | undefined;
    usage: number;
    isTutor: boolean;
}

const initialState: AppState = {
    initialHistoryData: undefined,
    selectedQuestionUuid: undefined,
    usage: 0,
    isTutor: false,
};

export const appStateSlice = createSlice({
    name: 'appState',
    initialState,
    reducers: {
        setInitialHistoryData: (state, action) => {
            state.initialHistoryData = action.payload;
        },
        setSelectedQuestionUuid: (state, action) => {
            state.selectedQuestionUuid = action.payload;
        },
        setUsage: (state, action) => {
            state.usage = action.payload;
        },
        setIsTutor: (state, action) => {
            state.isTutor = action.payload;
        },
    },
});

export const selectors = {
    isTutor: (state: AppState) => state.isTutor,
};
